/**
 * Logic for hide cookie alert
 */
const $ = jQuery.noConflict();

function cookiesAlert() {
	const cookiesBar = $('.cookies-alert');

	if (!cookiesBar) {
		return;
	}

	cookiesBar.find('.cookies-alert__accept').on('click', () => {
		const now = new Date();
		now.setTime(now.getTime() + 30 * 24 * 60 * 60 * 1000); // 1 year
		document.cookie = `cookies_alert=1;expires=${now.toUTCString()};path=/`;
		cookiesBar.remove();
	});

	cookiesBar.find('.cookies-alert__close').on('click', () => {
		cookiesBar.remove();
	});
}

export default cookiesAlert;
